<!-- <app-fat-top-bar-layout [setupObs]="layoutSetup" [showSitesSelector]="false"></app-fat-top-bar-layout> -->
 <router-outlet></router-outlet>